import { useState, useCallback, useEffect, useMemo } from "react";
/**
 * Handles navigation in a menu list or matrix, by holding the active item index and declaring methods for easy navigation.
 */
export function useListNavigation({ length, }) {
    const [activeIndex, setActiveIndex] = useState(0);
    useEffect(() => {
        setActiveIndex(0);
    }, [length]);
    const up = useCallback(() => {
        setActiveIndex((index) => {
            const targetIndex = index - 1;
            return targetIndex < 0 ? length - 1 : targetIndex;
        });
    }, [length]);
    const down = useCallback(() => {
        setActiveIndex((index) => {
            const targetIndex = index + 1;
            return targetIndex >= length ? 0 : targetIndex;
        });
    }, [length]);
    const set = useCallback((index) => {
        setActiveIndex(index);
    }, []);
    return useMemo(() => ({ activeIndex, set, down, up }), [activeIndex, set, up, down]);
}
